module.exports = function() {
  return new Worker(__webpack_public_path__ + "a66075669d8d0ac2d740.worker.js");
};